import '../scss/main.scss';

import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';

window.IcfMain = (function () {
  function start() {
    setupBorderPerEnv();
  }

  function setupBorderPerEnv() {
    const hostname = window.location.hostname;
    const isStaging = hostname.indexOf('staging') !== -1;
    const isDevelopment = hostname.indexOf('localhost') !== -1;
    if (isStaging || isDevelopment) {
      const mainClass = isStaging ? 'staging' : 'development';
      const innerText = mainClass.toUpperCase();
      const body = document.querySelector('body');
      const bDiv = document.createElement('DIV');
      bDiv.classList.add(mainClass);
      bDiv.classList.add('bottom');
      bDiv.innerText = `***  ${innerText}  ***`;
      const tDiv = document.createElement('DIV');
      tDiv.classList.add(mainClass);
      tDiv.classList.add('top');
      const lDiv = document.createElement('DIV');
      lDiv.classList.add(mainClass);
      lDiv.classList.add('left');
      const rDiv = document.createElement('DIV');
      rDiv.classList.add(mainClass);
      rDiv.classList.add('right');
      body.appendChild(rDiv);
      body.appendChild(lDiv);
      body.appendChild(tDiv);
      body.appendChild(bDiv);
    }
  }

  function logout() {
    const logoutEl = document.getElementById('user-logout');
    if (logoutEl) {
      logoutEl.click();
    }
  }

  document.addEventListener('DOMContentLoaded', start);

  return {
    logout,
  };
})();
